export default "__VITE_ASSET__rT$iTKYB__"